<template>
    <DialogRoot>
                <DialogTrigger>
                    <button class="bg-[#3c41e9] text-white font-light h-[40px] w-[200px] rounded-lg">Créer une offre</button>
                </DialogTrigger>
                <DialogPortal>
                    <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
                    <DialogContent className="fixed text-black p-0 overflow-hidden w-[48%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                        <div class="bg-[#eeeeee] px-5 py-8">
                            <DialogTitle class="font-light">Ajouter une offres</DialogTitle>
                        </div>
                        <div class="p-5">
                            <div class="flex items-start gap-x-3 w-full">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="title" class="font-extralight">Titre <span class="text-[#f00]">*</span></label>
                                    <input type="text" v-model="form.title" name="title" placeholder="Master Génie logiciel" autoComplete="off" class="h-[45px] w-full border rounded-lg p-3"/>
                                </div>
                            </div>

                            <div class="flex items-start gap-x-3 w-full mt-4">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="description" class="font-extralight">Description du poste<span class="text-[#f00]">*</span></label>
                                    <textarea name="description" v-model="form.description" class="h-[40vh] border rounded-lg p-3 w-full"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="h-[1px] w-full bg-[#ccc]" />
                        <div class="flex items-center justify-end px-5 py-5 gap-x-5">
                            <DialogClose as-child>
                                <button type="button" class="border py-3 px-8 rounded-md">
                                    Fermer
                                </button>
                            </DialogClose>
                            <button v-on:click="createNewOffer" :disabled="asSend" type="button" class="py-3 px-8 rounded-md text-white bg-[#5357ec]">
                                <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                <span v-else>Enregistrer</span>
                            </button>
                        </div>
                    </DialogContent>
                </DialogPortal>
            </DialogRoot>
</template>
<script>
import toast from "@/components/ui/toast";
import API from "@/service/API";
import {Loader2} from "lucide-vue-next";
import {
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue';
export default {
    name: 'AddJobView',
    components:{
        Loader2,
        DialogRoot,
        DialogTrigger,
        DialogPortal,
        DialogOverlay,
        DialogContent,
        DialogTitle,
        DialogClose,
    },
    data(){
        return {
            asSend: false,
            form:{
                title:"",
                description:""
            }
        }
    },
    methods:{
        createNewOffer(){
            if(this.form.title.trim() === "" || this.form.description.trim() === ""){
                toast.error("Erreur","Veuillez remplir tous les champs obligatoires",4000);
                return;
            }
            this.asSend = true;
            API.post("jobs",this.form)
            .then(res=>{
                if(res.data.status){
                    toast.success("Succès","Offre créée avec succès",4000);
                    window.location.reload();
                }
            })
            .catch(()=>{
                toast.error("Erreur","Une erreur est survenue lors de la création de l'offre",4000);
            })
            .finally(()=>{
                this.asSend = false;
            })
        }
    }
};
</script>